import {ActionTree, GetterTree, Module, MutationTree} from 'vuex';
import {RootState} from '../../RootState';
import axios from "axios";
import {settings} from "@/plugins/settings";
import {IErrors} from "@/model/IErrors";
import responseHandler from "@/plugins/errorHandling";

interface LockerServiceProviderState {
  lockersProviderIds: number[];
  inconsistentProviderIds: number[];
  errors: IErrors;
}

const state: LockerServiceProviderState = {
  lockersProviderIds: [],
  inconsistentProviderIds: [],
  errors: {},
};

const getters: GetterTree<LockerServiceProviderState, RootState> = {
  lockersProviderIds: (state): number[] => state.lockersProviderIds,
  inconsistentProviderIds: (state): number[] => state.inconsistentProviderIds,
  errors: (state) => state.errors,
};

const actions: ActionTree<LockerServiceProviderState, RootState> = {
  fetchLockersProviderIds: ({ commit }, lockerId): any => {
    return responseHandler.handle(
      () => axios({
        url: settings.endpoint + 'serviceProviders/lockers/' + lockerId
      }),
      commit,
      'connectionIdsLoaded'
    );
  },
  connectLockerProvider: ({ commit }, {lockerId, serviceProviderId, connect}): any => {
    return responseHandler.handle(
      () => axios({
        url: settings.endpoint + 'serviceProviders/' + serviceProviderId + '/lockers/' + lockerId,
        method: connect ? 'PUT' : 'DELETE',
      }),
      commit,
      'connectionIdsLoaded'
    )
  },
  moveUp: ({ commit }, {lockerId, serviceProviderId}): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'serviceProviders/' + serviceProviderId + '/lockers/' + lockerId + '/up',
      method: 'POST',
    }),
    commit,
    'connectionIdsLoaded'
  ),
  moveDown: ({ commit }, {lockerId, serviceProviderId}): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'serviceProviders/' + serviceProviderId + '/lockers/' + lockerId + '/down',
      method: 'POST',
    }),
    commit,
    'connectionIdsLoaded'
  ),
  errors: ({commit}, errors: IErrors): any => {
    commit('errors', errors);
  }
};

interface IConnectedServiceProvider {
  id: number;
  channel_inconsistency: boolean;
}

const mutations: MutationTree<LockerServiceProviderState> = {
  connectionIdsLoaded(state, payload: {serviceProviders: IConnectedServiceProvider[]}) {
    state.lockersProviderIds = payload.serviceProviders.map(each => each.id);
    state.inconsistentProviderIds = payload.serviceProviders
      .filter(each => each.channel_inconsistency)
      .map(each => each.id);
  },
  errors(state, payload: IErrors) {
    state.errors = payload;
  },
};

const namespaced: boolean = true;

export const lockerServiceProviderModule: Module<LockerServiceProviderState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
